/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit MedicalForm/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaToggle from 'DesignSystem/TysiaToggle/index'
import TysiaToggleButton from 'DesignSystem/TysiaToggle/TysiaToggleButton/index'
import TysiaToggleText from 'DesignSystem/TysiaToggle/TysiaToggleText/index'



/** @type {import('Simple/types.js').View} */
export default function MedicalForm({
  children,
  viewPath = "/App/Account/Content/Settings/Content/Leads/Content/Content/Settings/Content/MedicalForm",
  onChange
  
}) {
let settingsMedicalFormEnabledValueData = fromData.useDataValue({ viewPath,
context: 'settings',
path: 'medicalFormEnabled',
})
let settingsMedicalFormEnabledChangeData = fromData.useDataChange({ viewPath,
context: 'settings',
path: 'medicalFormEnabled',
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<TysiaToggle
  viewPath={`${viewPath}/TysiaToggle`}
 justifyContent="flex-start"
 marginTop={dtSpaceS}
 data="settings.medicalFormEnabled"
 value={settingsMedicalFormEnabledValueData}
 onChange={settingsMedicalFormEnabledChangeData}
>
{childProps => (
<React.Fragment>
<TysiaToggleButton
{...childProps}
  viewPath={`${viewPath}/TysiaToggleButton`}
 paddingTop={0}
 paddingBottom={0}
 paddingRight={0}
 paddingLeft={0}
/>
<TysiaToggleText
{...childProps}
  viewPath={`${viewPath}/TysiaToggleText`}
 marginLeft={dtSpaceXs}
 text="Present medical form link after appointment is scheduled."
/>
</React.Fragment>
)}
</TysiaToggle>
{children}
</React.Fragment>)
}